import styled from 'styled-components';

const ShareFormWrapper = styled.div`
  .share-report {
    border: 1px solid #eee;
    border-radius: 0 0 10px 10px;
    input {
      outline: none;
    }
  }
  #quill-rt-editor {
    height: 100%;
    .quill {
      min-height: 200px;
      .ql-container {
        border: none;
        min-height: inherit;
        .ql-editor {
          min-height: inherit;
        }
      }
    }
    .ql-toolbar {
      border: none;
    }
  }
  .btn {
    cursor: pointer;
    user-select: none;
  }
  .client-select-container {
    border: 1px solid #eee;
    border-bottom: none;
    padding: 10px 20px;
    border-radius: 10px 10px 0 0;
    .value_selector__control {
      border-bottom: none !important;
    }
  }
  .opacity-50 {
    opacity: 0.5;
  }
  .w30mn {
    min-width: 30%;
  }
`;

export { ShareFormWrapper };
